const MAX_RECENT_DAYS = 7;

export default function isDateNear(
  dateInput: Date | string,
  days = MAX_RECENT_DAYS
): boolean {
  const dateObj = new Date(dateInput);

  const now = new Date();
  const diff = Math.abs(now.getTime() - dateObj.getTime());
  return diff < 1000 * 60 * 60 * 24 * days;
}
